import { DefaultOptions } from "@apollo/client";

// don't cache anything
export const DEFAULT_OPTIONS: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};
